import { IGenericResponse } from '../../../interfaces/shared.interface';
import { apiRQ } from '../../api';
import { useMutation } from 'react-query';
import { getHttpMethod } from '../../helpers';

const updateCreateExpense = async (variables: any): Promise<IGenericResponse> => {
  const resp = await apiRQ[getHttpMethod(variables?.id)]<IGenericResponse>('/admin/expenses/', { data: variables });

  return resp.data;
};

export const useUpdateCreateExpense = () => {
  return useMutation<IGenericResponse, Error>(updateCreateExpense);
};

const deleteExpense = async (data: any): Promise<IGenericResponse> => {
  const resp = await apiRQ.delete<IGenericResponse>('/admin/expenses/', { data });

  return resp.data;
};

export const useDeleteExpense = () => {
  return useMutation<IGenericResponse, Error>(deleteExpense);
};
